// Короткая сторона экрана, с которой устройство считается планшетом. Та же
// граница, что у Android (sw600dp) и у Chrome, когда он решает, называть ли
// себя мобильным: у телефонов короткая сторона не больше 470 px, у планшетов
// и раскрытых складных «книжек» — от 600. Между ними только бюджетные
// планшеты с завышенной плотностью (533–598): их и Android считает
// телефонами, и оверлей они получают как телефоны
export const TABLET_MIN_SCREEN_SHORT_SIDE = 600;

/**
 * Телефон ли это — по короткой стороне экрана, а не по размеру окна.
 *
 * По ширине окна телефон от планшета не отличить: длинные телефоны в
 * горизонтали доходят до 1000 px и больше, а планшеты на 7–8 дюймов бывают
 * шириной всего 960. Экран же от поворота, клавиатуры и панелей браузера не
 * зависит. Берем меньшую из сторон: Android при повороте меняет width и
 * height местами, iOS всегда отдает вертикальные.
 *
 * Исключение — браузеры с защитой от отпечатков (Tor, Firefox с
 * resistFingerprinting, приватный режим Safari на iPad): вместо экрана они
 * отдают размер окна, и планшет с горизонтальным окном ниже 600 px сойдет там
 * за телефон. Надежного признака таких браузеров нет, с этим миримся.
 *
 * @returns {boolean} false и тогда, когда размеры экрана неизвестны
 */
export const checkIfPhoneScreen = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const shortSide = Math.min(Number(window.screen?.width), Number(window.screen?.height));
  // Нулевые и нечисловые размеры (страница отрисована вне экрана) сравнение
  // с нулем отсекает само: NaN > 0 ложно
  return shortSide > 0 && shortSide < TABLET_MIN_SCREEN_SHORT_SIDE;
};
